"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var useCheckDisabledArrows = function (parentDiv) {
    var _a = tslib_1.__read(React.useState(false), 2), isDisabledLeftArrow = _a[0], setIsDisabledLeftArrow = _a[1];
    var _b = tslib_1.__read(React.useState(false), 2), isDisabledRightArrow = _b[0], setIsDisabledRightArrow = _b[1];
    var handleScrollArrows = React.useCallback(function () {
        if (!parentDiv)
            return;
        var howMuchHasScrolled = parentDiv.scrollLeft;
        var parentWidth = parentDiv.clientWidth;
        var maxScroll = parentDiv.scrollWidth - parentDiv.clientWidth;
        if (howMuchHasScrolled === 0) {
            setIsDisabledLeftArrow(true);
        }
        if (howMuchHasScrolled > 0) {
            setIsDisabledLeftArrow(false);
        }
        if (howMuchHasScrolled < parentWidth) {
            setIsDisabledRightArrow(false);
        }
        if (howMuchHasScrolled >= maxScroll) {
            setIsDisabledRightArrow(true);
        }
    }, [parentDiv]);
    React.useEffect(function () {
        handleScrollArrows();
    }, [handleScrollArrows]);
    return { isDisabledLeftArrow: isDisabledLeftArrow, isDisabledRightArrow: isDisabledRightArrow, handleScrollArrows: handleScrollArrows };
};
exports.default = useCheckDisabledArrows;
